
export const getFileName = ( key: string ): string =>
	key.split( "/" ).filter( Boolean ).pop() ?? "";

export const getFileType = ( key: string ): string | null => {
	const extension = key.split( "." ).filter( Boolean ).pop()?.toLowerCase() ?? "";
	const knownTypes = ["pdf", "doc", "docx", "xls", "xlsx"];
	return knownTypes.includes( extension ) ? extension : null;
};

export const formatFileSize = ( bytes: number, decimals = 1 ) => {
	if ( bytes === 0 ) return "0 B";
	const k = 1024;
	const sizes = ["B", "KB", "MB", "GB", "TB", "PB"];
	const i = Math.floor( Math.log( bytes ) / Math.log( k ) );
	const dm = decimals < 0 || i < 2 ? 0 : decimals;

	return parseFloat( ( bytes / Math.pow( k, i ) ).toFixed( dm ) ) + " " + sizes[i];
};